import { Button, Flex, HStack, List, ListItem, Stack, Tag, TagCloseButton, TagLabel, Text, VStack } from '@chakra-ui/react';
import { useFilterListingContextProvider } from '../../context/FilterListingContext';

const FilterEmpty = () => {
  const { finialAreaFilterResult, finialBuildTypeFilterResult, onRemoveBuildType, onRemoveCity, resultNum, applyFilter } =
    useFilterListingContextProvider();
  return (
    <Flex direction={'column'} bgColor={'gray.50'} w={'full'} py={8} px={4}>
      <Text w={'full'} textAlign={'center'} fontWeight={'500'} fontSize={'18px'} color={'blackAlpha.900'}>
        0 筆結果，可嘗試：
      </Text>
      <List spacing={3}>
        <ListItem>
          <VStack
            direction={{
              md: 'column',
              lg: 'row',
            }}
            w={'full'}
            justify={{
              md: 'start',
              lg: 'center',
            }}
            align={{
              md: 'start',
              lg: 'center',
            }}
          >
            <Text
              mt={4}
              mb={2}
              textAlign={'left'}
              fontSize={{
                md: 4,
                lg: 16,
              }}
              color={'gray.700'}
            >
              放寬篩選條件：
            </Text>
            <HStack>
              {finialAreaFilterResult.cities.map((item) => {
                return (
                  <Tag
                    onClick={() => {
                      onRemoveCity(item, true);
                    }}
                    borderRadius={0}
                    textColor={'black'}
                    size={'md'}
                    h={10}
                    key={item}
                    bgColor={'gray.100'}
                    variant='solid'
                  >
                    <TagLabel>{item}</TagLabel>
                    <TagCloseButton />
                  </Tag>
                );
              })}
              {finialBuildTypeFilterResult.map((item) => {
                return (
                  <Tag
                    onClick={() => {
                      onRemoveBuildType(item, true);
                    }}
                    borderRadius={0}
                    textColor={'black'}
                    size={'md'}
                    h={10}
                    key={item}
                    bgColor={'gray.100'}
                    variant='solid'
                  >
                    <TagLabel>{item}</TagLabel>
                    <TagCloseButton />
                  </Tag>
                );
              })}
            </HStack>
          </VStack>
        </ListItem>
      </List>
    </Flex>
  );
};
export default FilterEmpty;
